import { FC } from 'react';
import { FormHelperText, Slider, Stack, Typography } from '@mui/material';
import { useField, useFormikContext } from 'formik';
import { SliderOwnProps } from '@mui/material/Slider/Slider';

export interface SliderInputProps extends SliderOwnProps {
  name: string;
  label?: string;
}

export const SliderInput: FC<SliderInputProps> = ({ name, ...props }) => {
  const { setFieldValue } = useFormikContext();
  const [field, meta] = useField(name);
  const midpoint = Math.round(((props.min ?? 0) + (props.max ?? 100)) / 2);
  const touched = field.value !== undefined && field.value !== null;
  const value = field.value ?? midpoint;
  const marks = Array.isArray(props.marks) ? props.marks : [];
  const minLabel = marks.length >= 1 ? marks[0].label : undefined;
  const maxLabel = marks.length >= 2 ? marks[marks.length - 1].label : undefined;
  const min = props.min ?? 0;
  const max = props.max ?? 100;
  const distToMin = Math.abs(value - min);
  const distToMax = Math.abs(value - max);
  const boldMin = touched && distToMin < distToMax ? 'bold' : 'normal';
  const boldMax = touched && distToMax < distToMin ? 'bold' : 'normal';

  return (
    <>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Typography fontWeight={boldMin}>{min}</Typography>
        <Slider
          {...props}
          marks
          value={value}
          onChange={(_, value) => setFieldValue(name, value)}
          onMouseDown={() => {
            if (field.value === undefined || field.value === null) setFieldValue(name, midpoint);
          }}
          onTouchStart={() => {
            if (field.value === undefined || field.value === null) setFieldValue(name, midpoint);
          }}
          sx={{ ...((props.sx as object) || {}) }}
        />
        <Typography fontWeight={boldMax}>{max}</Typography>
      </Stack>
      {(minLabel || maxLabel) && (
        <Stack direction="row" justifyContent="space-between" sx={{ mt: 1 }}>
          <Typography variant="body2" fontWeight={boldMin}>
            {minLabel}
          </Typography>
          <Typography variant="body2" fontWeight={boldMax}>
            {maxLabel}
          </Typography>
        </Stack>
      )}
      {meta.touched && meta.error && <FormHelperText error>{meta.error}</FormHelperText>}
    </>
  );
};
